import _ from "lodash";

export default {
    roomFileList: (state, getters, rootState, rootGetters) => {
        return _.sortBy(state.roomFileList, ['regDate']).reverse();
    },
    allowedRoomFileExts: (state, getters, rootState, rootGetters) => {
        return state.allowedRoomFileExts;
    },
    uploadRoomFileList: (state, getters, rootState, rootGetters) => {
        return state.uploadRoomFileList;
    },
    findByRoomFileId:(state, getters) => ({fileInfo: {fileId}}) => {
        return state.roomFileList.find(el => el.roomFileId == fileId);
    },
}

